import { TriangleAlert } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { useCompanyPath, useRBAC } from '@/lib/hooks'

const SERVICE_LABELS = {
  totalProjects: 'Projects',
  totalApps: 'Apps',
  totalDatabases: 'Databases',
  totalStaticSites: 'Static sites',
  totalObjectStorages: 'Object storages',
  totalLoadBalancers: 'Load balancers',
  totalPipelines: 'Pipelines',
} as const

export const BlockedState = () => {
  const { totalServices } = useRBAC()
  const { navigateToPath } = useCompanyPath()

  const remainingServices = Object.entries(SERVICE_LABELS)
    .map(([key, label]) => ({
      label,
      total: totalServices[key as keyof typeof SERVICE_LABELS],
    }))
    .filter(({ total }) => total > 0)

  return (
    <Alert>
      <TriangleAlert className="size-4" />
      <AlertTitle>Remove your projects and services first</AlertTitle>
      <AlertDescription>
        <p>
          This company cannot be deleted while it still has projects or
          services. Delete the following, then come back here:
        </p>
        <ul className="list-disc pl-4 mt-2">
          {remainingServices.map(({ label, total }) => (
            <li key={label}>
              {label}: {total}
            </li>
          ))}
        </ul>
        <Button
          variant="outline"
          className="mt-3"
          onClick={() => navigateToPath({ pathname: '/' })}
        >
          View projects
        </Button>
      </AlertDescription>
    </Alert>
  )
}
